import React from 'react'

const LanguajeSkills = () => {
    return ( 
        <div className="right">

            <div className="about_title">
            <h3>Language Skills</h3>
            </div>

            {/* END TITLE */}
            <div className="tokyo_progress">

            <div className="progress_inner" data-value="95">
                <span>
                <span className="label">English</span>
                <span className="number">90%</span>
                </span>
                <div className="background">
                <div className="bar">
                <div className="bar_in" style={{width: 90 + '%'}}></div>
                </div>
                </div>
            </div>

            </div>
            
        </div>
    );
}
 
export default LanguajeSkills;